import { userManager } from '../services/auth.service'
import { User } from 'oidc-client'
import { getAccessTokenParam } from '../../utils/helpers'
import appConfig from 'app.config'
import { appInsights } from 'AppInsight'
import { getCountryA3 } from 'utils/helpers'
import axios from 'axios'

let tokenInfo: Partial<User> = {}

export async function getHeadersWithJwtToken() {
	const { access_token, expires_at, profile } =
		(await userManager.getUser()) || { access_token: getAccessTokenParam() }
	if (access_token && tokenInfo.access_token !== access_token) {
		tokenInfo = { expires_at, profile, access_token }
		appInsights.trackEvent({
			name: 'user got a token',
			properties: { expires_at, profile },
		})
	}
	return {
		headers: {
			Authorization: access_token && `Bearer ${access_token}`,
			'Customer-Id': profile?.sub,
			'System-Version': getSystemVersionHeaderValue(),
			market: getCountryA3(),
		},
	}
}

const getSystemVersionHeaderValue = () => {
	return `MyPages-${appConfig.country} (${appConfig.environment})`
}

export async function getSubFromClaims() {
	const { profile } = (await userManager.getUser()) || {
		access_token: getAccessTokenParam(),
	}
	return profile?.sub
}

export async function getBirthdateFromClaims() {
	const { profile } = (await userManager.getUser()) || {
		access_token: getAccessTokenParam(),
	}
	return profile?.[
		'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/dateofbirth'
	]
}

function retrieveAxiosCancelToken() {
	let cancelSource = axios.CancelToken.source()

	/** Enhance reset functionality to immediately replace the cancelSource
	with a new one, ensuring the old one cannot be reused. */
	const resetCancelToken = () => {
		cancelSource = axios.CancelToken.source()
	}

	/** Getter for the token to ensure encapsulation and direct access
	to the current token without directly exposing cancelSource. */
	const getToken = () => {
		return cancelSource.token
	}

	/** Cancel function that directly uses the current cancelSource,
	allowing for cancellation without external access to cancelSource. */
	const cancel = (message: string) => {
		cancelSource.cancel(message)
	}

	return { getToken, resetCancelToken, cancel }
}

export const authenticationServiceCancelToken = retrieveAxiosCancelToken()
